import React, { useEffect, useState } from "react";
import axios from "axios";

const POLL_MS = 120000;

const LoaderIcon = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
    {...props}
  >
    <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" />
  </svg>
);

/**
 * In-app banner when asset-manifest.json changes (new SPA build).
 * Same behaviour as react-update-popup: baseline from first fetch, compare to later polls.
 */
const UpdateNotification = ({
  title = "App update available",
  description = "Reload this page to use the latest version of the app.",
  buttonText = "Reload now",
  assetManifestUrl = "/asset-manifest.json",
  onReload,
}) => {
  const [baseline, setBaseline] = useState(null);
  const [current, setCurrent] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const fetchManifest = async () => {
      try {
        const res = await axios.get(`${assetManifestUrl}?_${Date.now()}`, {
          responseType: "text",
          transformResponse: [(data) => data],
        });
        if (cancelled) return;
        const text = res.data;
        setCurrent(text);
        setBaseline((prev) => (prev === null ? text : prev));
      } catch {
        /* ignore */
      }
    };

    fetchManifest();
    const intervalId = window.setInterval(fetchManifest, POLL_MS);

    return () => {
      cancelled = true;
      window.clearInterval(intervalId);
    };
  }, [assetManifestUrl]);

  const reload = onReload || (() => typeof window !== "undefined" && window.location.reload());
  const updateAvailable = baseline !== null && current !== null && current !== baseline;

  if (!updateAvailable) {
    return null;
  }

  return (
    <div className="update-notification-popup">
      <div className="update-notification-popup__icon">
        <LoaderIcon />
      </div>
      <div className="update-notification-popup__row">
        <div className="update-notification-popup__copy">
          <h3 className="update-notification-popup__title">{title}</h3>
          <p className="update-notification-popup__desc">{description}</p>
        </div>
        <button type="button" className="update-notification-popup__action" onClick={reload}>
          {buttonText}
        </button>
      </div>
    </div>
  );
};

export default UpdateNotification;
